import React from "react";

const HowItWorksSection: React.FC = () => {
  return (
    <section
      style={{
        backgroundColor: "rgb(10 192 171 / 1)",
        color: "#fff",
        padding: "80px 20px",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "36px", fontWeight: 700, marginBottom: "20px" }}>
        Get started in less than <span style={{ color: "#000" }}>5 minutes</span>
      </h1>
      <p
        style={{
          fontSize: "18px",
          maxWidth: "600px",
          margin: "0 auto 30px",
        }}
      >
        And reveal your store’s full potential with reliable adblock-proof ad
        tracking.
      </p>
      <button
        style={{
          backgroundColor: "#fff",
          color: "#000",
          padding: "15px 30px",
          border: "none",
          borderRadius: "8px",
          fontSize: "16px",
          fontWeight: 600,
          cursor: "pointer",
          marginBottom: "20px",
        }}
      >
        Start 14 day free trial
      </button>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
          fontSize: "16px",
          marginBottom: "50px",
        }}
      >
        <span>✓ Set up in 5 minutes</span>
        <span>✓ No coding required</span>
        <span>✓ Exceptional 24/7 support</span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          backgroundColor: "rgba(0, 0, 0, 0.1)",
          padding: "40px 20px",
          flexWrap: "wrap",
        }}
      >
        {[
          { value: "4000+", label: "Brands thriving with us" },
          { value: "24/7", label: "Exceptional support" },
          { value: "4.9/5", label: "Avg. rating by our users" },
          { value: "64%", label: "Savings in ad spend" },
          { value: "3x", label: "Revenue from ads" },
        ].map((item, index) => (
          <div key={index} style={{ textAlign: "center", margin: "15px" }}>
            <h2 style={{ fontSize: "28px", color: "#fff" }}>{item.value}</h2>
            <p style={{ fontSize: "14px", color: "#e2e2e2" }}>{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorksSection;
